import React from 'react'
import { Text, View } from "@react-pdf/renderer"
import { DataField } from "../../../Label"
import { formatInBrazilianDate } from "../../../../../utils/functions"
import DataUnavailableText from "../../DataUnavailableText"
import ErrorDataText from "../../ErrorDataText"

const RestrictionListVariableReport = (props) => {
  const { restrictionsData } = props
  try {
    return (
      restrictionsData?.consists ? (
        restrictionsData?.restrictions?.map((restriction) => {
          return (
            <View key={`restriction:${restriction.uuid}`}>
              <Text style={{ marginBottom: 10 }}>{restriction?.list_name}</Text>
              <DataField label="Nome:" value={restriction?.subject_name} />
              <DataField
                label="Pseudônimo(s):"
                value={restriction?.pseudonyms ? restriction?.pseudonyms : 'N/A'}
              />
              <DataField
                label="Data da Entrada:"
                value={restriction?.entry_date ? formatInBrazilianDate(restriction?.entry_date) : 'N/A'}
              />
              <DataField
                label="Data da Saída:"
                value={restriction?.exit_date ? formatInBrazilianDate(restriction?.exit_date) : 'permanece na lista restritiva'}
              />
            </View>
          )
        })
      ) : (
        <DataUnavailableText />
      )
    )
  } catch (err) {
    return (
      <ErrorDataText
        exception={err}
        contextName="RestrictionListVariableReport"
        extraData={restrictionsData}
      />
    )
  }
}

export default RestrictionListVariableReport
